/**
 * RotationStreet icon registry — refined line icons for private markets UI.
 * 24×24 grid, 1.75 stroke, geometric & restrained.
 */

/** @typedef {string | string[] | { d: string, fill?: string }[]} IconDef */

/** @type {Record<string, IconDef>} */
export const ICON_PATHS = {
  home: 'M4 10.2 12 4l8 6.2V20a1.2 1.2 0 0 1-1.2 1.2H15v-6.5H9V21.2H5.2A1.2 1.2 0 0 1 4 20V10.2z',
  dashboard: ['M4 4h7v7H4z', 'M13 4h7v4h-7z', 'M13 10h7v10h-7z', 'M4 13h7v7H4z'],
  deal: ['M3 8.5V18a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8.5', 'M8 8.5V6a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2.5', 'M3 10.5h18'],
  postDeal: ['M12 4v10', 'M7.5 9.5 12 14l4.5-4.5', 'M5 20h14'],
  search: ['M10.5 18a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15z', 'M16.2 16.2 21 21'],
  progress: ['M4 18V6', 'M9 18v-5', 'M14 18v-8', 'M19 18V4'],
  activity: 'M4 14.5 8.5 10 13 14.5 20 7',
  chat: ['M5 6.5h14a2 2 0 0 1 2 2v6.5a2 2 0 0 1-2 2H10l-4.5 3.5V8.5a2 2 0 0 1 2-2z'],
  email: ['M4 7.5h16v9a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-9z', 'M4 7.5l8 5.5 8-5.5'],
  mail: ['M4 7.5h16v9a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-9z', 'M4 7.5l8 5.5 8-5.5'],
  files: ['M8 4h7l3 3v13a1.5 1.5 0 0 1-1.5 1.5h-10A1.5 1.5 0 0 1 5 20V5.5A1.5 1.5 0 0 1 6.5 4z', 'M14 4v4h4'],
  fileText: ['M8 4h7l3 3v13a1.5 1.5 0 0 1-1.5 1.5h-10A1.5 1.5 0 0 1 5 20V5.5A1.5 1.5 0 0 1 6.5 4z', 'M9 12h6', 'M9 16h4'],
  digest: ['M5 5h14v3H5z', 'M5 10.5h14', 'M5 14h10', 'M5 17.5h8'],
  upgrade: ['M12 4v12', 'M7.5 10.5 12 6l4.5 4.5', 'M5 20h14'],
  settings: ['M12 15.2a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4z', 'M19.4 14.5a1.4 1.4 0 0 0 .3 1.5l.05.05a1.7 1.7 0 0 1-1.2 2.9 1.7 1.7 0 0 1-1.2-.5l-.05-.05a1.4 1.4 0 0 0-1.5-.3 1.4 1.4 0 0 0-.85 1.3V20a1.7 1.7 0 0 1-3.4 0v-.1a1.4 1.4 0 0 0-.9-1.3 1.4 1.4 0 0 0-1.5.3l-.05.05a1.7 1.7 0 0 1-2.9-1.2 1.7 1.7 0 0 1 .5-1.2l.05-.05a1.4 1.4 0 0 0 .3-1.5 1.4 1.4 0 0 0-1.3-.85H4a1.7 1.7 0 0 1 0-3.4h.1a1.4 1.4 0 0 0 1.3-.9 1.4 1.4 0 0 0-.3-1.5l-.05-.05a1.7 1.7 0 0 1 1.2-2.9 1.7 1.7 0 0 1 1.2.5l.05.05a1.4 1.4 0 0 0 1.5.3h.05a1.4 1.4 0 0 0 .85-1.3V4a1.7 1.7 0 0 1 3.4 0v.1a1.4 1.4 0 0 0 .9 1.3 1.4 1.4 0 0 0 1.5-.3l.05-.05a1.7 1.7 0 0 1 2.9 1.2 1.7 1.7 0 0 1-.5 1.2l-.05.05a1.4 1.4 0 0 0-.3 1.5v.05a1.4 1.4 0 0 0 1.3.85H20a1.7 1.7 0 0 1 0 3.4h-.1a1.4 1.4 0 0 0-1.3.9z'],
  users: ['M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z', 'M3.5 20v-.8c0-2.4 2.4-4.2 5.5-4.2s5.5 1.8 5.5 4.2V20', 'M16.5 11.2a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z', 'M15 20v-.6c0-1.6 1.4-2.9 3.5-3.2'],
  members: ['M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z', 'M3.5 20v-.8c0-2.4 2.4-4.2 5.5-4.2s5.5 1.8 5.5 4.2V20', 'M16.5 11.2a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z', 'M15 20v-.6c0-1.6 1.4-2.9 3.5-3.2'],
  chart: ['M5 19V9', 'M10 19V5', 'M15 19v-7', 'M20 19V3'],
  barChart: ['M5 19V9', 'M10 19V5', 'M15 19v-7', 'M20 19V3'],
  dollar: ['M12 3v18', 'M15.5 7.5A3.5 3.5 0 0 0 8.5 9c0 2.2 2.8 2.5 5.5 3.2 2.4.6 3 1.8 3 3.3a3.5 3.5 0 0 1-7 1'],
  calendar: ['M7 4V2.5', 'M17 4V2.5', 'M4.5 9h15', 'M6 5.5h12a2 2 0 0 1 2 2V19a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7.5a2 2 0 0 1 2-2z'],
  meeting: ['M7 4V2.5', 'M17 4V2.5', 'M4.5 9h15', 'M6 5.5h12a2 2 0 0 1 2 2V19a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7.5a2 2 0 0 1 2-2z'],
  fund: ['M5 20V9l7-4 7 4v11', 'M9 20v-5h6v5', 'M9 12h6'],
  portfolio: ['M5 20V9l7-4 7 4v11', 'M9 20v-5h6v5', 'M9 12h6'],
  bank: ['M4 10h16', 'M6 10V18', 'M10 10V18', 'M14 10V18', 'M18 10V18', 'M4 18h16', 'M12 4l8 4H4l8-4z'],
  shield: 'M12 3.5 19 6.5V12c0 4.2-3 7.8-7 8.5-4-.7-7-4.3-7-8.5V6.5L12 3.5z',
  bell: ['M12 4.5a4.5 4.5 0 0 1 4.5 4.5v3.5l1.5 2.5H6l1.5-2.5V9A4.5 4.5 0 0 1 12 4.5z', 'M10 18.5h4'],
  bellOff: ['M5.5 5.5 18.5 18.5', 'M9.5 9.3A4.4 4.4 0 0 1 12 8.8c2.2 0 4 1.6 4.3 3.7', 'M6 15.5h12', 'M10 18.5h4'],
  lock: ['M7 11V8a5 5 0 0 1 10 0v3', 'M6 11h12v8.5H6z'],
  collaborate: ['M8 11.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z', 'M16 11.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z', 'M4.5 19.5v-.6c0-2 2.2-3.4 5-3.4', 'M14.5 19.5v-.6c0-2 2.2-3.4 5-3.4', 'M9.5 13.5l5 2'],
  video: ['M16 8.5l4.5-2.5v11.5L16 15', 'M5 7.5h9a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2z'],
  globe: ['M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z', 'M3 12h18', 'M12 3c2.8 3 2.8 15 0 18', 'M12 3c-2.8 3-2.8 15 0 18'],
  clock: ['M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z', 'M12 7v5l3.5 2'],
  alert: ['M12 5.5 20.5 19h-17L12 5.5z', 'M12 10v4', 'M12 17h.01'],
  alertTriangle: ['M12 5.5 20.5 19h-17L12 5.5z', 'M12 10v4', 'M12 17h.01'],
  policy: ['M12 4.5v15', 'M7.5 8.5h9', 'M6 20.5h12', 'M8.5 6.5 6 8.5', 'M15.5 6.5 18 8.5'],
  report: ['M6 4.5h9l3 3V19.5a1.5 1.5 0 0 1-1.5 1.5h-10.5A1.5 1.5 0 0 1 5 19.5V6A1.5 1.5 0 0 1 6.5 4.5z', 'M8.5 12h7', 'M8.5 16h5'],
  image: ['M5 6.5h14v11H5z', 'M9 11.5l2-2 3 3 2.5-2.5L19 14.5', 'M9 9.5h.01'],
  zap: 'M13 3.5 8.5 13H12l-1 7.5L16 11h-3.5L13 3.5z',
  pin: ['M12 21V11', 'M8.5 6.5a3.5 3.5 0 1 1 7 0c0 2.2-3.5 4.5-3.5 4.5S8.5 8.7 8.5 6.5z'],
  copy: ['M9 8.5H7.5A1.5 1.5 0 0 0 6 10v8.5A1.5 1.5 0 0 0 7.5 20H16a1.5 1.5 0 0 0 1.5-1.5V17', 'M9 6h8.5A1.5 1.5 0 0 1 19 7.5V16'],
  expand: ['M9 4.5H4.5V9', 'M15 4.5h4.5V9', 'M9 19.5H4.5V15', 'M15 19.5h4.5V15', 'M4.5 4.5l5 5', 'M19.5 4.5l-5 5', 'M4.5 19.5l5-5', 'M19.5 19.5l-5-5'],
  megaphone: ['M5 10.5v3l4 2.5V8L5 10.5z', 'M12 9.5h2.5a3 3 0 0 1 0 6H12', 'M9 8.5v7'],
  sparkles: ['M12 3.5v3', 'M12 17.5v3', 'M4.5 12h3', 'M16.5 12h3', 'M6.8 6.8l2.1 2.1', 'M15.1 15.1l2.1 2.1', 'M17.2 6.8l-2.1 2.1', 'M8.9 15.1l-2.1 2.1'],
  clipboard: ['M9 5.5h6', 'M10 4.5h4a1 1 0 0 1 1 1V7H9V5.5a1 1 0 0 1 1-1z', 'M8 7.5h8v11.5H8z'],
  logout: ['M10 7.5 6.5 11 10 14.5', 'M6.5 11H16', 'M16 5.5h2.5V18.5H16'],
  contracts: ['M8 4.5h7l3 3v12a1.5 1.5 0 0 1-1.5 1.5H8A1.5 1.5 0 0 1 6.5 19.5V6A1.5 1.5 0 0 1 8 4.5z', 'M15 16.5l2 2 4-4'],
  listings: ['M6 7.5h12', 'M6 12h12', 'M6 16.5h8', 'M4.5 5.5h15v13h-15z'],
  payment: ['M4 8.5h16a1.5 1.5 0 0 1 1.5 1.5v7A1.5 1.5 0 0 1 20 18.5H4A1.5 1.5 0 0 1 2.5 17v-7A1.5 1.5 0 0 1 4 8.5z', 'M2.5 11h19'],
  plus: ['M12 6v12', 'M6 12h12'],
  trash: ['M5 7.5h14', 'M9.5 7.5V6a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v1.5', 'M8 7.5v10.5h8V7.5', 'M10 11v5', 'M14 11v5'],
  externalLink: ['M14 5.5h4.5V10', 'M10 14 18.5 5.5', 'M9 7.5H6.5A1.5 1.5 0 0 0 5 9v8.5A1.5 1.5 0 0 0 6.5 19H15a1.5 1.5 0 0 0 1.5-1.5V15'],
  moderation: ['M12 3.5 19 6.5V12c0 4.2-3 7.8-7 8.5-4-.7-7-4.3-7-8.5V6.5L12 3.5z', 'M9.5 12.5 11 14l3.5-4'],
  admin: ['M12 3.5 19 6.5V12c0 4.2-3 7.8-7 8.5-4-.7-7-4.3-7-8.5V6.5L12 3.5z', 'M9.5 12.5 11 14l3.5-4'],
  folder: ['M4.5 7.5h5l1.5 2h9v9.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4.5 19V7.5z'],
  inbox: ['M4 7.5h16v9a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-9z', 'M4 7.5l8 5.5 8-5.5'],
  campaign: ['M5 10.5v3l4 2.5V8L5 10.5z', 'M12 9.5h2.5a3 3 0 0 1 0 6H12'],
  translate: ['M5 8h8', 'M9 8v10', 'M14 12h5', 'M16.5 9.5 19 12l-2.5 2.5'],
  security: ['M7 11V8a5 5 0 0 1 10 0v3', 'M6 11h12v8.5H6z'],
  check: 'M6.5 12.5 10 16l7.5-8',
  chevronRight: 'M9.5 7.5 14.5 12l-5 4.5',
  star: 'M12 4.5 14.4 9.3 19.5 10l-3.8 3.3 1.1 5-4.8-2.8-4.8 2.8 1.1-5L4.5 10l5.1-.7L12 4.5z',
  trendUp: 'M4 16.5 9 11.5 13.5 16 20 8.5',
  info: ['M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z', 'M12 11v5', 'M12 8h.01'],
  warning: ['M12 5.5 20.5 19h-17L12 5.5z', 'M12 10v4', 'M12 17h.01'],
  timer: ['M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z', 'M12 7v5l3 2'],
  scissors: ['M8.5 6.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z', 'M15.5 17.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z', 'M6 20 18 4'],
  puzzle: ['M10 4.5h2.5a1.5 1.5 0 0 1 1.5 1.5V8h2.5a1.5 1.5 0 0 1 1.5 1.5v2.5H14a1.5 1.5 0 0 0-1.5 1.5V16H10a1.5 1.5 0 0 0-1.5-1.5V12H6a1.5 1.5 0 0 1-1.5-1.5V8H7a1.5 1.5 0 0 0 1.5-1.5V6A1.5 1.5 0 0 1 10 4.5z'],
  building: ['M5 20V9l7-4 7 4v11', 'M9 20v-5h6v5', 'M9 12h2', 'M13 12h2'],
  newspaper: ['M5 6.5h14v11H5z', 'M8 10h8', 'M8 13.5h5', 'M8 17h8'],
  download: ['M12 15V5', 'M8.5 11.5 12 7l3.5 4.5', 'M5 19h14'],
  upload: ['M12 16V6', 'M7.5 10.5 12 6l4.5 4.5', 'M5 20h14'],
  close: ['M7.5 7.5 16.5 16.5', 'M16.5 7.5 7.5 16.5'],
  link: ['M10 8.5h-.5a4 4 0 0 0 0 8h.5', 'M14 15.5h.5a4 4 0 0 0 0-8H14', 'M9 12h6'],
  creditCard: ['M4 8.5h16a1.5 1.5 0 0 1 1.5 1.5v7A1.5 1.5 0 0 1 20 18.5H4A1.5 1.5 0 0 1 2.5 17v-7A1.5 1.5 0 0 1 4 8.5z', 'M2.5 11h19'],
  key: ['M7 11V8a5 5 0 0 1 9.2-2.5', 'M15 12.5l4 2.5v3'],
  pen: ['M16.5 4.5 19.5 7.5 8 19H5v-3L16.5 4.5z'],
  mobile: ['M9 5.5h6a1.5 1.5 0 0 1 1.5 1.5v10A1.5 1.5 0 0 1 15 18.5H9A1.5 1.5 0 0 1 7.5 17V7A1.5 1.5 0 0 1 9 5.5z', 'M11 16h2'],
  palette: ['M12 3.5a8.5 8.5 0 0 0 0 17h1.5a1.5 1.5 0 0 0 0-3H12a2 2 0 0 1-2-2c0-1 .8-1.8 1.8-1.8H14a2.5 2.5 0 0 0 0-5H12z', 'M8 10h.01', 'M10.5 7h.01', 'M13.5 7h.01'],
  coinvest: ['M8 11.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z', 'M16 11.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z', 'M9.5 13.5l5 2'],
  templates: ['M8 4.5h7l3 3v12a1.5 1.5 0 0 1-1.5 1.5H8A1.5 1.5 0 0 1 6.5 19.5V6A1.5 1.5 0 0 1 8 4.5z', 'M8.5 12h7', 'M8.5 16h5'],
  tracking: ['M5 19V9', 'M10 19V5', 'M15 19v-7', 'M20 19V3', 'M4 20h16'],
  dispute: ['M12 4.5v15', 'M7.5 8.5h9', 'M6 20.5h12'],
  feedback: ['M5 6.5h14a2 2 0 0 1 2 2v6.5a2 2 0 0 1-2 2H10l-4.5 3.5V8.5a2 2 0 0 1 2-2z'],
  review: ['M10.5 18a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15z', 'M16.2 16.2 21 21'],
  spreadsheet: ['M5 5.5h14v13H5z', 'M9 5.5v13', 'M5 10h14', 'M5 14.5h14'],
  archive: ['M5 8.5h14v10.5H5z', 'M8 8.5V6.5h8v2', 'M10 12.5h4'],
  phone: ['M8.5 5.5h7a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2z', 'M11 17.5h2'],
  userPlus: ['M10 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6z', 'M4.5 19.5v-.8c0-2.2 2.5-3.7 5.5-3.7', 'M17 9.5v6', 'M14 12.5h6'],
  briefcase: ['M3 8.5V18a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8.5', 'M8 8.5V6a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2.5', 'M3 10.5h18'],
  messageSquare: ['M5 6.5h14a2 2 0 0 1 2 2v6.5a2 2 0 0 1-2 2H10l-4.5 3.5V8.5a2 2 0 0 1 2-2z'],
}

export const STAT_ICON_MAP = {
  deals: { icon: 'chart', tone: 'green' },
  lps: { icon: 'users', tone: 'orange' },
  raised: { icon: 'dollar', tone: 'blue' },
  dd: { icon: 'calendar', tone: 'purple' },
  portfolio: { icon: 'fund', tone: 'blue' },
  exposure: { icon: 'dollar', tone: 'blue' },
  chat: { icon: 'chat', tone: 'orange' },
  plan: { icon: 'calendar', tone: 'purple' },
  files: { icon: 'files', tone: 'blue' },
  meetings: { icon: 'meeting', tone: 'purple' },
  funding: { icon: 'dollar', tone: 'green' },
  contacts: { icon: 'users', tone: 'purple' },
  clients: { icon: 'users', tone: 'gold' },
  storage: { icon: 'folder', tone: 'blue' },
  access: { icon: 'shield', tone: 'green' },
}

export const DIGEST_TYPE_ICONS = {
  deal: 'fund',
  market: 'chart',
  policy: 'policy',
  report: 'report',
  members: 'members',
}

export const PORTAL_NAV_ICONS = {
  home: 'home',
  post_deal: 'postDeal',
  find_deal: 'search',
  in_progress: 'progress',
  chat: 'chat',
  email: 'email',
  files: 'files',
  digest: 'digest',
  payment: 'upgrade',
  settings: 'settings',
  assets: 'portfolio',
}
